<template>
    <div class="sustainable-component wage-result-individual">
        <!--
    <div class="bg-success mb-3 p-3 rounded">vue component wage-result-individual</div>
    -->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" label="Anställd" :items="employees" v-model="selectedEmployeeId" item-title="CompleteName" item-value="EmployeeId"></v-select>
                </div>
                <div class="col-6">
                    <a href="javascript:void(0)" @click="printIndividualsSalary">Visa individens utvecklingsstatus och lön</a>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
                <div class="col-6">
                    <a href="javascript:void(0)" @click="printSalariesSinglePosition">Visa utvecklingsstatus och lön inom befattning</a><br />
                    <a href="javascript:void(0)" @click="printAllPositionSalaries">Visa utvecklingsstatus och lön inom alla befattningar</a><br />
                    <a href="javascript:void(0)" @click="printSalaryAnalysis">Visa samtliga individers utvecklingsstatus och lön</a>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-result-individual',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async loadEmployees() {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromCompany("Fornamn");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printSalariesSinglePosition() {
                var selPosition = this.selectedPosition;
                if (selPosition == null || selPosition == "null") {
                    alert("Välj en befattning")
                    return;
                }
                this.newWindow = window.open('/wagesettingsprint/printIndividualsSalary?employeeId=&jobPositionId=' + selPosition, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async printAllPositionSalaries() {
                this.newWindow = window.open('/wagesettingsprint/printIndividualsSalary?employeeId=&jobPositionId=','','left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async printIndividualsSalary() {
                var selEmployeeId = this.selectedEmployeeId;
                if(selEmployeeId == null || selEmployeeId == "null")
                    selEmployeeId = "";
                this.newWindow = window.open('/wagesettingsprint/printIndividualsSalary?employeeId=' + selEmployeeId + '&jobPositionId=', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async printSalaryAnalysis() {
                 var selEmployeeId = this.selectedEmployeeId;
                 if(selEmployeeId == null || selEmployeeId == "null")
                     selEmployeeId = "";
                var positionName = "";
                var selPosition = this.selectedPosition;
                if(selPosition == null || selPosition == "null")
                    selPosition = "";
                else
                {
                    for (var i = 0; i < this.internalModel.JobPositions.length; i++) {
                        if( this.selectedPosition == this.internalModel.JobPositions[i].JobPositionId){
                            positionName = this.internalModel.JobPositions[i].Name;
                        }
                    }
                }
                this.newWindow = window.open('/wagesettingsprint/printSalaryAnalysis?employeeId=' + selEmployeeId + '&JobPositionName=' + positionName, 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                employees: [],
                selectedEmployeeId: null,
                selectedPosition: null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
            this.loadEmployees();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
